import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_ASIGNATURE } from "../../Constants/DatatableColumns";
import { PENCIL,LOGOUT_ICON } from "../../Constants/SrcImages";
import { Row, Col, Container, Label, Button } from "reactstrap";
import {validateTokenStorage} from './../../Constants/Util';
import { AdminAddAsignature } from "./../../Constants/Modal";
import { getAsignature, postAsignature,putAsignature, deleteAsignature,getAreas } from "../../Constants/Services";
import { IArea,IAsignatureAdmin } from "./../../Constants/Interfaces";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IAsignatureState {
  dataAsignature: IAsignatureAdmin[];
  dataSubAsignature: IAsignatureAdmin[];
  dataAsignatureSelected: IAsignatureAdmin;
  isOpenModalAddAsignature: boolean;
  isOpenModalEditAsignature:boolean;
  dataArea:IArea[];
  handling_sub: boolean;
  loading:boolean;
  as_motherName:string;
  msg_error:string;
}

class Materias extends Component<RouteComponentProps<{}>, IAsignatureState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataArea:[],
      dataAsignature: [],
      dataSubAsignature: [],
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_sub: "0",
        as_plan: "",
        as_mother: "",
        as_area:""
      },
      as_motherName:"",
      isOpenModalAddAsignature: false,
      isOpenModalEditAsignature: false,
      handling_sub: false,
      loading:false,
      msg_error:""
    };

    this.fetchAsignature = this.fetchAsignature.bind(this);
    this.handlerPostAsignature = this.handlerPostAsignature.bind(this);
    this.onChangeAsignature = this.onChangeAsignature.bind(this);
    this.handlerModalAddAsignature = this.handlerModalAddAsignature.bind(this);
    this.handleAddSubmateria = this.handleAddSubmateria.bind(this);
    this.handlerModalEditAsignature = this.handlerModalEditAsignature.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerDataEdit = this.handlerDataEdit.bind(this);
    this.columnModalEditAsignarture = this.columnModalEditAsignarture.bind(this);
    this.handlerPutAsignature = this.handlerPutAsignature.bind(this);
    this.handlerDeleteAsignature = this.handlerDeleteAsignature.bind(this);
    this.setArea = this.setArea.bind(this);
    this.fetchArea =this.fetchArea.bind(this);
  }

  async fetchArea() {
    const response = await getAreas();
    this.setState({
      dataArea: response,
      loading: false,
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_sub: "0",
        as_plan: "",
        as_mother: "",
        as_area:""
      },
    });
  }

  async fetchAsignature() {
    const response = await getAsignature();
    this.setState({
      dataAsignature: response.marterias,
      handling_sub: false,
      loading: false,
      dataSubAsignature: response.submaterias,
      msg_error:"",
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_sub: "0",
        as_plan: "",
        as_mother: "",
        as_area:""
      }
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchAsignature();
    this.fetchArea();
  }

  rechargeData() {
    this.setState({ loading: true,msg_error:"" });
    setTimeout(() => {
      this.fetchAsignature();
    }, 1000);
  }
  
  handlerPutAsignature() {
    const props = this.state.dataAsignatureSelected;
    const body = {
      as_id:props.as_id,
      as_desc: props.as_desc,
      as_area: props.ar_id
    };
    if(props.as_desc.length>0 && props.ar_id.length>0){
      putAsignature(body);
      this.setState({ isOpenModalAddAsignature: false, handling_sub: false });
      if (props.as_mother.length > 0) {
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        setTimeout(() => {
          this.fetchAsignature();
        }, 2000);
      }
    }
    else{
      this.setState({msg_error:"Algunos campos estan vacios"})
    }

  }
  handlerPostAsignature() {
    const props = this.state.dataAsignatureSelected;
    const body = {
      as_sub: props.as_sub,
      as_desc: props.as_desc,
      as_mother: props.as_mother,
      as_area: props.ar_id
    };
    if(props.as_desc.length>0 && props.ar_id.length){
      postAsignature(body);
      this.setState({ isOpenModalAddAsignature: false, handling_sub: false });
      if (props.as_mother.length > 0) {
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        setTimeout(() => {
          this.fetchAsignature();
        }, 2000);
      }
    }
    else{
      this.setState({msg_error:"Algunos campos estan vacios"})
    }
  }

  onChangeAsignature(e: any) {
    this.setState({
      dataAsignatureSelected: {
        ...this.state.dataAsignatureSelected,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  handlerModalAddAsignature() {
    this.setState((prevState) => ({
      isOpenModalAddAsignature: !prevState.isOpenModalAddAsignature,
      handling_sub: false,
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_sub: "0",
        as_plan: "",
        as_mother: "",
        as_area:""
      },
      msg_error:""
    }));
  }

  handlerModalEditAsignature() {
    this.setState((prevState) => ({
      isOpenModalEditAsignature: !prevState.isOpenModalEditAsignature,
      isOpenModalAddAsignature:false,
      handling_sub: false,
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_mother: "",
        as_sub: "0",
        as_plan: "",
        as_area:""
      },
      msg_error:""
    }));
  }

  handleAddSubmateria(row) {
    this.setState({
      dataAsignatureSelected: {
        ar_id:"",
        ar_desc:"",
        as_id: "",
        as_desc: "",
        as_mother: row.as_id,
        as_sub: "0",
        as_plan: "",
        as_area:""
      },
      as_motherName: row.as_desc,
      handling_sub: true,
      isOpenModalAddAsignature: true,
      msg_error:""
    });
  }

  handlerAddSubmateria = (cell: string, row: any) => {
    const props = this.state;
    if (row.as_sub === "1") {
      return (
        <Row>
          <Col xs={8} className="text-center m-auto">
            {props.dataSubAsignature.map((data, i) => {
              if (data.as_mother === row.as_id) {
                return (
                  <React.Fragment key={data.as_id}>
                    <Row>
                      <Col xs={8} className="text-left">
                      <Label>{data.as_desc}</Label>
                      </Col>
                      <Col  xs={4} className="d-flex">
                     {/* <br></br> */}
                    <img className="img-status img-search" onClick={() => this.handlerDataEdit(data)} src={PENCIL} alt="" />
                    <img className="img-status img-search" onClick={() => this.handlerDeleteAsignature(data)} src={LOGOUT_ICON} alt="" />
                      </Col>
                    </Row>
                   
                  </React.Fragment>
                );
              } else {
                return null;
              }
            })}
          </Col>
          <Col xs={4} className="text-center m-auto">
            <Button color="primary" className="w-100" onClick={() => this.handleAddSubmateria(row)}>
              Agregar
            </Button>
          </Col>
        </Row>
      );
    }
  };

  handlerDataEdit = (row: any) => {
    this.setState({
      dataAsignatureSelected: row,
      isOpenModalEditAsignature: true,
      msg_error:""
    });
  };

  handlerDeleteAsignature = (row: any) => {
    const body = {
      as_id:row.as_id,
    };

    deleteAsignature(body);
    
    this.setState({ loading: true});
    if (row.as_mother.length > 0) {
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } else {
      setTimeout(() => {
        this.fetchAsignature();
      }, 2000);
    }
  };

  columnModalEditAsignarture(cell:number, row:any) {
    return (
      <React.Fragment>
        <Row>
          <Col xs={4}>
          </Col>
          <Col xs={4} className="d-flex">
            <Label className="txt-underline" onClick={() => this.handlerDataEdit(row)}>
              {row.as_desc}
            </Label>
            <img className="img-status img-search" onClick={() => this.handlerDataEdit(row)} src={PENCIL} alt="" />
            <img className="img-status img-search" onClick={() => this.handlerDeleteAsignature(row)} src={LOGOUT_ICON} alt="" />
          </Col>
          <Col xs={4}>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  setSubmateria = (as_sub: string) => {
    this.setState({
      dataAsignatureSelected: {
        ...this.state.dataAsignatureSelected,
        as_sub,
      },
    });
  };

  setArea = ({ar_id,ar_desc}) => {
    this.setState({
      dataAsignatureSelected: {
        ...this.state.dataAsignatureSelected,
        ar_id,
        ar_desc,
      },
    });
  };
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddAsignature && (
          <AdminAddAsignature
            title="Agregar materia"
            dataFAsignature={props.dataAsignatureSelected}
            isOpen={props.isOpenModalAddAsignature}
            toggle={this.handlerModalAddAsignature}
            toggleSave={this.handlerPostAsignature}
            onChange={this.onChangeAsignature}
            setSubmateria={this.setSubmateria}
            handling_sub={props.handling_sub}
            handleSub={true}
            as_motherName={props.as_motherName}
            msg_error={props.msg_error}
            datArea={props.dataArea}
            setArea={this.setArea}
          />
        )}

      {props.isOpenModalEditAsignature && (
          <AdminAddAsignature
            title="Editar materia"
            dataFAsignature={props.dataAsignatureSelected}
            isOpen={props.isOpenModalEditAsignature}
            toggle={this.handlerModalEditAsignature}
            toggleSave={this.handlerPutAsignature}
            onChange={this.onChangeAsignature}
            setSubmateria={this.setSubmateria}
            handling_sub={props.handling_sub}
            handleSub={false}
            as_motherName={props.as_motherName}
            msg_error={props.msg_error}
            datArea={props.dataArea}
            setArea={this.setArea}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Materias</h3>
                </Col>
                <Col sm={12} className="text-right">
                <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                  <Button color="success" onClick={() => this.handlerModalAddAsignature()}>
                    Agregar Materia
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataAsignature}
                    columns={COLUMNS_ASIGNATURE(this.handlerAddSubmateria, this.columnModalEditAsignarture)}
                    keyProp="as_id"
                    exportD={false}
                    searchs={false}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Materias;